import { Box, HStack, Text } from '@chakra-ui/react'
import { useThemeColors } from '@/hooks/useThemeColors'

type Props = {
  title: string
  children: React.ReactNode
  rightAction?: React.ReactNode
}

export default function OverviewSectionCard({ title, children, rightAction }: Props) {
  const colors = useThemeColors()

  return (
    <Box>
      <HStack justify="space-between" align="center" mb={2}>
        <Text
          fontWeight="700"
          color={colors.textSecondary}
          fontSize="sm"
          textTransform="uppercase"
          letterSpacing="wider"
        >
          {title}
        </Text>
        {rightAction ?? null}
      </HStack>
      <Box
        p={4}
        bg={colors.sectionBg ?? colors.cardBg}
        borderWidth="1px"
        borderColor={colors.border}
        borderRadius="md"
      >
        {children}
      </Box>
    </Box>
  )
}
